/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown>, label: NonNullable<unknown> }} Media_Choose_AriaInputs */

const vi_media_choose_aria = /** @type {(inputs: Media_Choose_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action}: ${i?.label}`)
};

/**

* @param {Media_Choose_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_choose_aria = /** @type {((inputs: Media_Choose_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Choose_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_choose_aria(inputs)
});